export const Brand = () => <>mpwrd<span style={{ color: "var(--orange)" }}>.</span>work</>;
